import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";

import * as projectReducer from "containers/Project/reducer";
import * as unifiedProjectReducer from "containers/UnifiedProject/reducer";
import * as setupReducer from "containers/Setup/reducer";
import * as consumerReducer from "containers/Consumer/reducer";
import * as monitoringReducer from "containers/Monitoring/reducer";
import * as businessReducer from "containers/Business/BusinessReducer";

import Consumer from "components/Consumer/Consumer";

const getId = (props) =>
  props && props.id
    ? props.id
    : props.match && props.match.params && props.match.params.id
      ? props.match.params.id
      : "new";

class ConsumerContainer extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    return <Consumer {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = getId(ownProps);

  return {
    init: (blueprintId, datasetId) => dispatch(unifiedProjectReducer.init(id, blueprintId, datasetId)),
    initRun: () => {},

    reloadProject: () => dispatch(consumerReducer.reloadProject()),

    updateDrilldownValue: (runId, drilldownValue) =>
      dispatch(projectReducer.updateDrilldownValue(id, runId, drilldownValue)),
    updateBusinessMode: (businessMode) => dispatch(businessReducer.updateBusinessMode(id, businessMode)),

    updateModelFeedback: (runId, modelId, isLiked) =>
      dispatch(projectReducer.updateModelFeedback(runId, modelId, isLiked)),

    updateDatasetId: (datasetId) => dispatch(consumerReducer.updateDatasetId(datasetId)),
    updateProjectId: (projectId) => dispatch(consumerReducer.updateProjectId(projectId)),
    updateMode: (mode) => dispatch(consumerReducer.updateMode(mode))
  };
};

const mapStateToProps = (state, ownProps) => {
  const id = consumerReducer.getProjectId(state);
  const optimized = projectReducer.getOptimized(state, id);
  const runId = optimized && optimized.innerId !== undefined ? optimized.innerId : id;
  const segmentId = projectReducer.getSegmentId(state, id);

  const datasetId = consumerReducer.getDatasetId(state);

  return {
    id: id,
    runId: runId,
    segmentId: segmentId,
    setup: setupReducer.getSetup(state, runId),

    monitoringData: monitoringReducer.getData(state, id),

    isError: projectReducer.getIsError(state, id),

    allScenarios: projectReducer.getAllScenarios(state, id),

    transactionLabel: setupReducer.getTransactionLabel(state, runId),
    outcomeLabel: setupReducer.getOutcomeLabel(state, runId),
    notPursuedTransactionLabel: setupReducer.getNotPursuedTransactionLabel(state, runId),
    trueAction: setupReducer.getTrueAction(state, runId),
    falseAction: setupReducer.getFalseAction(state, runId),
    unitType: setupReducer.getUnitType(state, runId),

    setupLabels: setupReducer.getSetupLabels(state, runId),

    isContinuous: setupReducer.getIsContinuous(state, runId),

    optimized: optimized,
    project: projectReducer.getProject(state, id),
    modelGroups: projectReducer.getModelGroups(state, id, true),
    businessMode: businessReducer.getBusinessMode(state, id),
    hasBusinessSetup: projectReducer.getHasBusinessSetup(state, id),

    primaryBusinessConstraintType: setupReducer.getPrimaryBusinessConstraintType(state, id, runId),

    isOverallSegment: projectReducer.getIsOverallSegment(state, id, runId),

    mode: consumerReducer.getMode(state),
    datasetId: datasetId,

    compliancePlot: monitoringReducer.getCompliancePlot(state, id),
    isMonitoringLoading: monitoringReducer.getIsLoading(state, id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(ConsumerContainer);
